/* Site-wide EX VAT / INCL VAT mode. One source of truth in localStorage, read by the header
 * toggle and by every price display — a product page opened in a fresh tab still has to agree
 * with the mode the customer picked on the catalog a minute ago. */
(() => {
  const KEY = "blankd-vat-mode";
  const valid = (m) => m === "ex" || m === "incl";

  const getMode = () => {
    try {
      const m = localStorage.getItem(KEY);
      return valid(m) ? m : "ex";
    } catch {
      return "ex";
    }
  };

  const setMode = (mode) => {
    if (!valid(mode)) return;
    try { localStorage.setItem(KEY, mode); } catch {}
    apply(mode);
    window.dispatchEvent(new CustomEvent("blankd:vat-change", { detail: { mode } }));
  };

  // Toggle buttons: a button with [data-bdn-vat], its state read off [data-mode].
  // Price pairs: any element carrying [data-vat-ex] / [data-vat-incl] is shown/hidden to match.
  function apply(mode) {
    document.querySelectorAll("[data-bdn-vat]").forEach((btn) => btn.setAttribute("data-mode", mode));
    document.querySelectorAll("[data-vat-ex]").forEach((el) => { el.hidden = mode !== "ex"; });
    document.querySelectorAll("[data-vat-incl]").forEach((el) => { el.hidden = mode !== "incl"; });
  }

  document.addEventListener("click", (e) => {
    const btn = e.target.closest("[data-bdn-vat]");
    if (!btn) return;
    setMode(getMode() === "ex" ? "incl" : "ex");
  });

  window.blankdVat = { getMode, setMode };
  apply(getMode());
  document.addEventListener("DOMContentLoaded", () => apply(getMode()));
})();
